// extracted by mini-css-extract-plugin
export default {"profession":"profession_profession__7OOxb","block":"profession_block__XIip-","img":"profession_img__JVFRI","name":"profession_name__vMHaf","text":"profession_text__4eFVo"};